export const API_URI = process.env.API_PUBLIC_URI;
export const SANDBOX = process.env.SANDBOX;
export const TEST_NAME = 'TEST';
